import React, { Component } from "react";
import { connect } from "react-redux";
import { throttle } from "lodash";
import { unscaledStart, unscaledDrag, end, getUnscaledTarget } from "./hotspot";

import {
  setHeldObject,
  setFragmentMass,
  reverseFragmentMass,
} from "./store/actions";

import "./styles.scss";

import dragIcon from "./img/drag-icon.svg";
import close from "./img/close.svg";

import bp754 from "./img/plasmid-results/754_bp.svg";
import bp807 from "./img/plasmid-results/807_bp.svg";
import bp1184 from "./img/plasmid-results/1184_bp.svg";
import bp1614 from "./img/plasmid-results/1614_bp.svg";
// import bp4705 from './img/plasmid-results/4705_bp.svg';
import bp5082 from "./img/plasmid-results/5082_bp.svg";
import bp8990 from "./img/plasmid-results/8990_bp.svg";
import bp9200 from "./img/plasmid-results/9200_bp.svg";
import bp9410 from "./img/plasmid-results/9410_bp.svg";
import para4872bp from "./img/plasmid-results/para_4872_bp.svg";
import paraR5302 from "./img/plasmid-results/para_r_5302_bp.svg";
import paraR377bp from "./img/plasmid-results/para_r_377_bp.svg";
import paraR4495bp from "./img/plasmid-results/para_r_4495_bp.svg";
import paraR4705bp from "./img/plasmid-results/4705_bp.svg";
import pkanR5512bp from "./img/plasmid-results/pkan_r_5512_bp.svg";

import { fetchTranslations } from "./locales/config";
import { TranslationsProvider } from "@learningblocks/simulations/shared-components";

import { injectIntl, FormattedMessage } from "react-intl";

const images = {
  754: bp754,
  807: bp807,
  1184: bp1184,
  1614: bp1614,
  5082: bp5082,
  8990: bp8990,
  9200: bp9200,
  9410: bp9410,
  4872: para4872bp,
  5302: paraR5302,
  377: paraR377bp,
  4495: paraR4495bp,
  4705: paraR4705bp,
  5512: pkanR5512bp,
};

class Predictions37 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      targetList: [],
      fragments: this.props.fragments,
      fragmentMoveMenu: [false, false, false, false],
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      targetList: [
        document.getElementById("dropzone-0"),
        document.getElementById("dropzone-1"),
        document.getElementById("dropzone-2"),
        document.getElementById("drop-area"),
      ],
    });
  }

  onDragStart = (e) => {
    let dragImage = document.getElementById("dragImage");

    if (dragImage == null) {
      dragImage = document.createElement("img");
      dragImage.id = "dragImage";
      dragImage.src =
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==";
      document.body.appendChild(dragImage);
    }

    const testVar = window.DataTransfer || window.Clipboard; // Clipboard is for Chrome
    if ("setDragImage" in testVar.prototype) {
      e.dataTransfer.setDragImage(dragImage, 0, 0);
    }
    if ("setData" in testVar.prototype) {
      e.dataTransfer.setData("text/plain", "");
    }

    const fragmentMoveMenu = this.state.fragmentMoveMenu;

    fragmentMoveMenu.forEach(function (fragment, innerIndex, arr) {
      arr[innerIndex] = false;
    });

    if (e.target.id.includes("fragment-")) {
      const tempId = parseInt(e.target.id.split("-")[1]);

      this.props.setHeldObject({
        type: "Solution",
        id: tempId,
        htmlObj: e.target,
      });

      e.target.parentNode.classList.add("dragged");
    }

    unscaledStart(e, e.target.parentNode);
  };

  drag = throttle((event) => {
    unscaledDrag(event);
  }, 20);

  onDragOver = (e) => {
    e.preventDefault();
    e.persist();
    this.drag(e, e.clientX, e.clientY);
  };

  onDrop = (e) => {
    e.preventDefault();

    const target = getUnscaledTarget(
      this.props.heldObject.htmlObj,
      this.state.targetList
    );

    if (target !== "") {
      if (target.id.includes("dropzone")) {
        const targetId = parseInt(target.id.split("-")[1]);

        const fragments = [807, 4705, 377, 4495];
        const mass = fragments[this.props.heldObject.id];

        this.props.setFragmentMass({
          id: targetId,
          mass: mass,
        });

        this.props.setHeldObject({
          type: null,
          id: -1,
          htmlObj: null,
        });

        this.props.heldObject.htmlObj.parentNode.classList.remove("dragged");
        this.props.heldObject.htmlObj.parentNode.style.transform =
          "translate3d(0px, 0px, 0px) rotateZ(0deg)";
      } else {
        this.props.heldObject.htmlObj.parentNode.classList.remove("dragged");
        this.props.heldObject.htmlObj.parentNode.style.transform =
          "translate3d(0px, 0px, 0px) rotateZ(0deg)";
      }
    } else {
      if (
        typeof this.props.heldObject.htmlObj !== "undefined" &&
        this.props.heldObject.htmlObj !== null
      ) {
        this.props.heldObject.htmlObj.parentNode.classList.remove("dragged");
        this.props.heldObject.htmlObj.parentNode.style.transform =
          "translate3d(0px, 0px, 0px) rotateZ(0deg)";
      }
    }

    end(e);
  };

  teleport = (id, targetId) => {
    const fragments = [807, 4705, 377, 4495];
    const mass = fragments[id];

    this.props.setFragmentMass({
      id: targetId,
      mass: mass,
    });
  };

  moveTo = (id, targetId) => {
    const fragmentMoveMenu = this.state.fragmentMoveMenu;

    fragmentMoveMenu.forEach(function (fragment, innerIndex, arr) {
      arr[innerIndex] = false;
    });

    this.setState({
      fragmentMoveMenu: fragmentMoveMenu,
    });

    this.teleport(id, targetId);
  };

  showMoveMenu = (e, index) => {
    // Hide all the menus
    const fragmentMoveMenu = this.state.fragmentMoveMenu;

    fragmentMoveMenu.forEach(function (fragment, innerIndex, arr) {
      if (index !== innerIndex) {
        arr[innerIndex] = false;
      }
    });

    // Toggle this menu
    fragmentMoveMenu[index] = !fragmentMoveMenu[index];

    if (fragmentMoveMenu[index] === true) {
      const elems = document.getElementsByClassName("fragment");
      for (let i = 0; i < elems.length; i++) {
        elems[i].style.zIndex = null;
      }
      e.target.parentNode.style.zIndex = 99;
    } else {
      e.target.parentNode.style.zIndex = null;
    }

    this.setState({
      fragmentMoveMenu: fragmentMoveMenu,
    });
  };

  section1 = () => {
    return (
      <div className="innerQBlock">
        <h5 style={{ margin: "5px 0px", fontSize: "18px" }}>
          <FormattedMessage
            id="Ligation products"
            defaultMessage="Ligation products"
            description=""
          />
        </h5>
        <div className="answerLine">
          <p>
            <FormattedMessage
              id="There are 10 possible products that can result from the ligation of the pKAN-R and pARA digest fragments. Please create the desired pARA-R recombinant plasmid, as well as two other potential recombinant plasmids that may form during the ligation process, by moving the fragments into the boxes below. The size of the resulting plasmids you create will be calculated and displayed below each plasmid."
              defaultMessage="There are 10 possible products that can result from the ligation of the pKAN-R and pARA digest fragments. Please create the desired pARA-R recombinant plasmid, as well as two other potential recombinant plasmids that may form during the ligation process, by moving the fragments into the boxes below. The size of the resulting plasmids you create will be calculated and displayed below each plasmid."
              description=""
            />
          </p>
        </div>
      </div>
    );
  };

  section2 = () => {
    return (
      <div className="innerQBlock">
        <div className="answerLine">
          <div className="innerStyle">
            <h4 className="section-title">
              <FormattedMessage
                id="pKAN-R digestion fragments:"
                defaultMessage="pKAN-R digestion fragments:"
                description=""
              />
            </h4>
            <div
              className="fragment fragment--container-margin"
              aria-label={this.props.intl.formatMessage({
                id: "807bp pKAN-R digestion fragment containing sections labelled rfp and pBAD.",
                defaultMessage:
                  "807bp pKAN-R digestion fragment containing sections labelled rfp and pBAD.",
                description: "",
              })}
              style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
            >
              <div
                aria-label={this.props.intl.formatMessage({
                  id: "Move this fragment to the following box.",
                  defaultMessage: "Move this fragment to the following box.",
                  description: "",
                })}
                onClick={(e) => {
                  this.showMoveMenu(e, 0);
                }}
                onKeyDown={(e) => {
                  if (e.keyCode === 13 || e.keyCode === 32) {
                    this.showMoveMenu(e, 0);
                  }
                }}
                draggable
                id="fragment-0"
                className="fragment__drag-indicator"
                role="button"
                tabIndex={0}
              >
                <img id="drag-img-control" src={dragIcon} alt="" />
                <div style={{ pointerEvents: "none", marginLeft: "17px" }}>
                  <FormattedMessage
                    id="drag"
                    defaultMessage="drag"
                    description=""
                  />
                </div>
              </div>
              <div className="fragment__readings">
                <div className="fragment__readings--labels Small-body-copy text-align-right">
                  <div>AGCTT</div>
                  <div>A</div>
                  <div>
                    <i>Hin</i>dIII
                  </div>
                </div>

                <div className="fragment__readings--dna-strands">
                  <div
                    id="rfp"
                    className=""
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "50%",
                      backgroundColor: "#e52826",
                    }}
                  >
                    <div
                      style={{ position: "relative", top: "-15px" }}
                      className="extra-small-body-copy"
                    >
                      <i>rfp</i>
                    </div>
                  </div>

                  <div className="">
                    <label htmlFor="pBAD" className="extra-small-body-copy">
                      &nbsp
                    </label>
                  </div>

                  <div
                    id="pBAD"
                    className=""
                    style={{
                      position: "relative",
                      right: "-25px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "35%",
                      backgroundColor: "#008d36",
                    }}
                  >
                    <div
                      style={{ position: "relative", top: "-15px" }}
                      className="extra-small-body-copy"
                    >
                      pBAD
                    </div>
                  </div>
                </div>

                <div className="fragment__readings--labels Small-body-copy text-align-left">
                  <div>G</div>
                  <div>CCTAG</div>
                  <div>
                    <i>Bam</i>HI
                  </div>
                </div>
              </div>
              <div className="fragment__value"> {"807 bp"} </div>
              <div
                className="fragment-move-menu"
                style={{
                  display: this.state.fragmentMoveMenu[0] ? null : "none",
                }}
              >
                <h6>
                  <FormattedMessage
                    id="Move to:"
                    defaultMessage="Move to:"
                    description=""
                  />
                </h6>
                <div>
                  <button
                    onClick={() => {
                      this.moveTo(0, 0);
                    }}
                  >
                    pARA-R
                  </button>
                  <button
                    onClick={() => {
                      this.moveTo(0, 1);
                    }}
                  >
                    <FormattedMessage
                      id="Possible 2nd plasmid"
                      defaultMessage="Possible 2nd plasmid"
                      description=""
                    />
                  </button>
                  <button
                    onClick={() => {
                      this.moveTo(0, 2);
                    }}
                  >
                    <FormattedMessage
                      id="Possible 3rd plasmid"
                      defaultMessage="Possible 3rd plasmid"
                      description=""
                    />
                  </button>
                </div>
              </div>
            </div>
            {/* <!-- end of fragment --> */}
            <div
              className="fragment fragment--container-margin"
              aria-label={this.props.intl.formatMessage({
                id: "4705 bp pKAN-R digestion fragment containing a section labelled kanR.",
                defaultMessage:
                  "4705 bp pKAN-R digestion fragment containing a section labelled kanR.",
                description: "",
              })}
              style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
            >
              <div
                tabIndex={0}
                role="button"
                aria-label={this.props.intl.formatMessage({
                  id: "Move this fragment to the following box.",
                  defaultMessage: "Move this fragment to the following box.",
                  description: "",
                })}
                onClick={(e) => {
                  this.showMoveMenu(e, 1);
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.showMoveMenu(e, 1);
                  }
                }}
                draggable
                id="fragment-1"
                className="fragment__drag-indicator"
              >
                <img src={dragIcon} alt="" />
                <div style={{ pointerEvents: "none", marginLeft: "17px" }}>
                  <FormattedMessage
                    id="drag"
                    defaultMessage="drag"
                    description=""
                  />
                </div>
              </div>
              <div
                id="bam-hi-control"
                className="fragment__readings"
                style={{ width: "68%", left: "-2px" }}
              >
                <div className="fragment__readings--labels Small-body-copy text-align-right">
                  <div>GATCC</div>
                  <div>G</div>
                  <div>
                    <i>Bam</i>HI
                  </div>
                </div>
                <div className="fragment__readings--dna-strands">
                  <div
                    id="kanR"
                    style={{
                      position: "relative",
                      left: "40%",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "45%",
                      backgroundColor: "#faac48",
                    }}
                    className=""
                  >
                    <div
                      style={{ position: "relative", top: "-15px" }}
                      className="extra-small-body-copy"
                    >
                      <i>kanR</i>
                    </div>
                  </div>
                </div>
                <div className="fragment__readings--labels Small-body-copy text-align-left">
                  <div>A</div>
                  <div>TTCGA</div>
                  <div>
                    <i>Hin</i>dIII
                  </div>
                </div>
              </div>
              <div className="fragment__value"> {"4705 bp"} </div>
              <div
                className="fragment-move-menu"
                style={{
                  display: this.state.fragmentMoveMenu[1] ? null : "none",
                }}
              >
                <h7 tabIndex={0}>{"Move to"}:</h7>
                <div>
                  <button
                    onClick={() => {
                      this.moveTo(1, 0);
                    }}
                  >
                    pARA-R
                  </button>
                  <button
                    onClick={() => {
                      this.moveTo(1, 1);
                    }}
                  >
                    <FormattedMessage
                      id="Possible 2nd plasmid"
                      defaultMessage="Possible 2nd plasmid"
                      description=""
                    />
                  </button>
                  <button
                    onClick={() => {
                      this.moveTo(1, 2);
                    }}
                  >
                    <FormattedMessage
                      id="Possible 3rd plasmid"
                      defaultMessage="Possible 3rd plasmid"
                      description=""
                    />
                  </button>
                </div>
              </div>
            </div>
            {/* <!-- end of fragment --> */}
            <div>
              <h4 className="section-title">
                <FormattedMessage
                  id="pARA digestion fragments:"
                  defaultMessage="pARA digestion fragments:"
                  description=""
                />
              </h4>
              <div
                className="fragment fragment--container-margin"
                aria-label={this.props.intl.formatMessage({
                  id: "377bp pARA digestion fragment containing no labelled sections.",
                  defaultMessage:
                    "377bp pARA digestion fragment containing no labelled sections.",
                  description: "",
                })}
                style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
              >
                <div
                  role="button"
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Move this fragment to the following box.",
                    defaultMessage: "Move this fragment to the following box.",
                    description: "",
                  })}
                  onClick={(e) => {
                    this.showMoveMenu(e, 2);
                  }}
                  onKeyDown={(e) => {
                    if (e.keyCode === 13 || e.keyCode === 32)
                      this.showMoveMenu(e, 2);
                  }}
                  draggable
                  id="fragment-2"
                  className="fragment__drag-indicator"
                >
                  <img src={dragIcon} alt="" />
                  <div style={{ pointerEvents: "none", marginLeft: "17px" }}>
                    <FormattedMessage
                      id="drag"
                      defaultMessage="drag"
                      description=""
                    />
                  </div>
                </div>
                <div
                  id="fragment__readings1"
                  className="fragment__readings"
                  style={{ width: "35%", left: "-87px" }}
                >
                  <div className="fragment__readings--labels Small-body-copy text-align-right">
                    <div>AGCTT</div>
                    <div>A</div>
                    <div>
                      <i>Hin</i>dIII
                    </div>
                  </div>

                  <div
                    className="fragment__readings--dna-strands"
                    id="nogene"
                  ></div>

                  <div className="fragment__readings--labels Small-body-copy text-align-left">
                    <div>G</div>
                    <div>CCTAG</div>
                    <div>
                      <i>Bam</i>HI
                    </div>
                  </div>
                </div>
                <div className="fragment__value"> 377 {"bp"} </div>
                <div
                  className="fragment-move-menu"
                  style={{
                    display: this.state.fragmentMoveMenu[2] ? null : "none",
                  }}
                >
                  <h7 tabIndex={0}>{"Move to"}:</h7>
                  <div>
                    <button
                      onClick={() => {
                        this.moveTo(2, 0);
                      }}
                    >
                      pARA-R
                    </button>
                    <button
                      onClick={() => {
                        this.moveTo(2, 1);
                      }}
                    >
                      <FormattedMessage
                        id="Possible 2nd plasmid"
                        defaultMessage="Possible 2nd plasmid"
                        description=""
                      />
                    </button>
                    <button
                      onClick={() => {
                        this.moveTo(2, 2);
                      }}
                    >
                      <FormattedMessage
                        id="Possible 3rd plasmid"
                        defaultMessage="Possible 3rd plasmid"
                        description=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              {/* <!-- end of fragment --> */}
              <div
                className="fragment fragment--container-margin"
                aria-label={this.props.intl.formatMessage({
                  id: "4495 bp pARA digestion fragment containing sections labelled araC, ori, and ampR.",
                  defaultMessage:
                    "4495 bp pARA digestion fragment containing sections labelled araC, ori, and ampR.",
                  description: "",
                })}
                style={{ transform: "translate3d(0,0,0) rotate(0deg)" }}
              >
                <div
                  role="button"
                  tabIndex={0}
                  aria-label={this.props.intl.formatMessage({
                    id: "Move this fragment to the following box.",
                    defaultMessage: "Move this fragment to the following box.",
                    description: "",
                  })}
                  onClick={(e) => {
                    this.showMoveMenu(e, 3);
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      this.showMoveMenu(e, 3);
                    }
                  }}
                  draggable
                  id="fragment-3"
                  className="fragment__drag-indicator"
                >
                  <img src={dragIcon} alt="" />
                  <div style={{ pointerEvents: "none", marginLeft: "17px" }}>
                    <FormattedMessage
                      id="drag"
                      defaultMessage="drag"
                      description=""
                    />
                  </div>
                </div>
                <div
                  id="fragment__readings2"
                  className="fragment__readings"
                  style={{ width: "68%", left: "-3px" }}
                >
                  <div className="fragment__readings--labels Small-body-copy text-align-right">
                    <div>GATCC</div>
                    <div>G</div>
                    <div>
                      <i>Bam</i>HI
                    </div>
                  </div>

                  <div className="fragment__readings--dna-strands">
                    <div
                      id="araC"
                      style={{
                        position: "relative",
                        left: "5%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "30%",
                        backgroundColor: "#1399f2",
                      }}
                    >
                      <div
                        style={{ position: "relative", top: "-15px" }}
                        className="extra-small-body-copy"
                      >
                        <i>araC</i>
                      </div>
                    </div>
                    <div
                      id="ori"
                      style={{
                        position: "relative",
                        left: "15%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "15%",
                        backgroundColor: "#333332",
                      }}
                    >
                      <div
                        style={{ position: "relative", top: "-15px" }}
                        className="extra-small-body-copy"
                      >
                        <i>ori</i>
                      </div>
                    </div>
                    <div
                      id="ampR"
                      style={{
                        position: "relative",
                        left: "25%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "20%",
                        backgroundColor: "#115f92",
                      }}
                    >
                      <div
                        style={{ position: "relative", top: "-15px" }}
                        className="extra-small-body-copy"
                      >
                        <i>ampR</i>
                      </div>
                    </div>
                  </div>

                  <div className="fragment__readings--labels Small-body-copy text-align-left">
                    <div>A</div>
                    <div>TTCGA</div>
                    <div>
                      <i>Hin</i>dIII
                    </div>
                  </div>
                </div>
                <div className="fragment__value">4495 bp</div>
                <div
                  className="fragment-move-menu"
                  style={{
                    display: this.state.fragmentMoveMenu[3] ? null : "none",
                  }}
                >
                  <h7 tabIndex={0}>
                    <FormattedMessage
                      id="Move to:"
                      defaultMessage="Move to:"
                      description=""
                    />
                  </h7>
                  <div>
                    <button
                      onClick={() => {
                        this.moveTo(3, 0);
                      }}
                    >
                      pARA-R
                    </button>
                    <button
                      onClick={() => {
                        this.moveTo(3, 1);
                      }}
                    >
                      <FormattedMessage
                        id="Possible 2nd plasmid"
                        defaultMessage="Possible 2nd plasmid"
                        description=""
                      />
                    </button>
                    <button
                      onClick={() => {
                        this.moveTo(3, 2);
                      }}
                    >
                      <FormattedMessage
                        id="Possible 3rd plasmid"
                        defaultMessage="Possible 3rd plasmid"
                        description=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              {/* <!-- end of fragment --> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  getFragment = (count) => {
    if (Object.hasOwn(images, count)) {
      return images[count];
    } else {
      return;
    }
  };

  getImage = (type) => {
    const count =
      parseInt(this.state.fragments[type][0], 10) +
      parseInt(this.state.fragments[type][1], 10);

    if (Object.hasOwn(images, count)) {
      return images[count];
    } else {
      return;
    }
  };

  reversePlasmidCalc = (lane, index) => {
    this.props.reverseFragmentMass({
      id: lane,
      index: index,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
  };

  handleChange = (event, text) => {
    const re = /^[0-9\b]+$/;
    text = event.target.value;

    if (text === "" || re.test(text)) {
      this.setState({
        predictions: {
          fragment: {
            [event.target.name]: event.target.value,
          },
        },
      });
    }
  };

  section3 = () => {
    return (
      <div className="innerQBlock">
        <div className="answerLine">
          <form style={{ display: "contents" }} onSubmit={this.handleSubmit}>
            <div className="drag-n-drop">
              <div className="drag-n-drop__header">
                <div style={{ fontSize: "13px" }}>pARA-R</div>
                <div style={{ fontSize: "13px" }}>
                  <FormattedMessage
                    id="Possible 2nd plasmid"
                    defaultMessage="Possible 2nd plasmid"
                    description=""
                  />
                </div>
                <div style={{ fontSize: "13px" }}>
                  <FormattedMessage
                    id="Possible 3rd plasmid"
                    defaultMessage="Possible 3rd plasmid"
                    description=""
                  />
                </div>
              </div>

              <div className="drag-n-drop__form">
                <div className="form">
                  <div className="form__row" id="drop-area">
                    <div className="form__row--label">
                      <FormattedMessage
                        id="Fragments"
                        defaultMessage="Fragments"
                        description=""
                      />
                    </div>

                    <div className="column">
                      {this.state.fragments.p_ARA_R[0] !== "0" ||
                      this.state.fragments.p_ARA_R[1] !== "0" ? (
                        <div id="dropzone-0">
                          {this.state.fragments.p_ARA_R[0] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.p_ARA_R[0]}
                                src={this.getFragment(
                                  this.state.fragments.p_ARA_R[0]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(0, 0);
                                  }
                                }}
                                onClick={() => {
                                  this.reversePlasmidCalc(0, 0);
                                }}
                              >
                                <img src={close} aria-hidden="true" alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.p_ARA_R[1] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.p_ARA_R[1]}
                                src={this.getFragment(
                                  this.state.fragments.p_ARA_R[1]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(0, 1);
                                  }
                                }}
                                onClick={() => {
                                  this.reversePlasmidCalc(0, 1);
                                }}
                              >
                                <img aria-hidden="true" src={close} alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.p_ARA_R[0] !== "0" &&
                          this.state.fragments.p_ARA_R[1] === "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-0"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.p_ARA_R[0] === "0" &&
                          this.state.fragments.p_ARA_R[1] !== "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-0"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="form__row--drop-zone" id="dropzone-0">
                          <FormattedMessage
                            id="Move here"
                            defaultMessage="Move here"
                            description=""
                          />
                        </div>
                      )}
                    </div>
                    <div className="column">
                      {this.state.fragments.plasm_2[0] !== "0" ||
                      this.state.fragments.plasm_2[1] !== "0" ? (
                        <div id="dropzone-1">
                          {this.state.fragments.plasm_2[0] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.plasm_2[0]}
                                src={this.getFragment(
                                  this.state.fragments.plasm_2[0]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(1, 0);
                                  }
                                }}
                                onClick={() => {
                                  this.reversePlasmidCalc(1, 0);
                                }}
                              >
                                <img src={close} aria-hidden="true" alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_2[1] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.plasm_2[1]}
                                src={this.getFragment(
                                  this.state.fragments.plasm_2[1]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(1, 1);
                                  }
                                }}
                                onClick={() => {
                                  this.reversePlasmidCalc(1, 1);
                                }}
                              >
                                <img src={close} aria-hidden="true" alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_2[0] !== "0" &&
                          this.state.fragments.plasm_2[1] === "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-1"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_2[0] === "0" &&
                          this.state.fragments.plasm_2[1] !== "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-1"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="form__row--drop-zone" id="dropzone-1">
                          <FormattedMessage
                            id="Move here"
                            defaultMessage="Move here"
                            description=""
                          />
                        </div>
                      )}
                    </div>
                    <div className="column">
                      {this.state.fragments.plasm_3[0] !== "0" ||
                      this.state.fragments.plasm_3[1] !== "0" ? (
                        <div id="dropzone-2">
                          {this.state.fragments.plasm_3[0] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.plasm_3[0]}
                                src={this.getFragment(
                                  this.state.fragments.plasm_3[0]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(2, 0);
                                  }
                                }}
                                onClick={() => {
                                  this.reversePlasmidCalc(2, 0);
                                }}
                              >
                                <img src={close} aria-hidden="true" alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_3[1] !== "0" ? (
                            <div className="frag">
                              <img
                                draggable="false"
                                alt={this.state.fragments.plasm_3[1]}
                                src={this.getFragment(
                                  this.state.fragments.plasm_3[1]
                                )}
                              />
                              <div
                                className="frag__remove"
                                role="button"
                                tabIndex={0}
                                aria-label={this.props.intl.formatMessage({
                                  id: "Remove fragment.",
                                  defaultMessage: "Remove fragment.",
                                  description: "",
                                })}
                                onClick={() => {
                                  this.reversePlasmidCalc(2, 1);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter" || e.key === " ") {
                                    this.reversePlasmidCalc(2, 1);
                                  }
                                }}
                              >
                                <img src={close} aria-hidden="true" alt="" />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_3[0] !== "0" &&
                          this.state.fragments.plasm_3[1] === "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-2"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {this.state.fragments.plasm_3[0] === "0" &&
                          this.state.fragments.plasm_3[1] !== "0" ? (
                            <div
                              className="form__row--drop-zone"
                              id="dropzone-2"
                            >
                              <FormattedMessage
                                id="Move here"
                                defaultMessage="Move here"
                                description=""
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                      ) : (
                        <div className="form__row--drop-zone" id="dropzone-2">
                          <FormattedMessage
                            id="Move here"
                            defaultMessage="Move here"
                            description=""
                          />
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form__row">
                    <div className="form__row--label">
                      <FormattedMessage
                        id="Resulting"
                        defaultMessage="Resulting"
                        description=""
                      />
                      <br />
                      <FormattedMessage
                        id="Plasmid"
                        defaultMessage="Plasmid"
                        description=""
                      />
                    </div>
                    <div className="column">
                      {this.state.fragments.p_ARA_R !== "0" ? (
                        <img
                          draggable="false"
                          src={this.getImage("p_ARA_R")}
                          alt=""
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="column">
                      {this.state.fragments.plasm_2 !== "0" ? (
                        <img
                          draggable="false"
                          src={this.getImage("plasm_2")}
                          alt=""
                        />
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="column">
                      {this.state.fragments.plasm_3 !== "0" ? (
                        <img
                          draggable="false"
                          src={this.getImage("plasm_3")}
                          alt=""
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  <div className="form__row">
                    <div className="form__row--label">
                      <FormattedMessage
                        id="Size (bp)"
                        defaultMessage="Size (bp)"
                        description=""
                      />
                    </div>
                    <div className="column">
                      <p className="prediction-mass">
                        {parseInt(this.state.fragments.p_ARA_R[0], 10) +
                          parseInt(this.state.fragments.p_ARA_R[1], 10) +
                          " " +
                          "bp"}
                      </p>
                    </div>
                    <div className="column">
                      <p className="prediction-mass">
                        {parseInt(this.state.fragments.plasm_2[0], 10) +
                          parseInt(this.state.fragments.plasm_2[1], 10) +
                          " " +
                          "bp"}
                      </p>
                    </div>
                    <div className="column">
                      <p className="prediction-mass">
                        {parseInt(this.state.fragments.plasm_3[0], 10) +
                          parseInt(this.state.fragments.plasm_3[1], 10) +
                          " " +
                          "bp"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="Predictions">
        <div
          className="outerQBlock"
          role="button"
          tabIndex={0}
          onDragStart={this.onDragStart}
          onDragOver={this.onDragOver}
          onDrop={this.onDrop}
          onMouseUp={this.onDrop}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              // Handle key press action here
            }
          }}
          onClick={() => {
            // Handle click action here
          }}
        >
          {this.section1()}
          {this.section2()}
          {this.section3()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    fragments: state.predictions.fragments,
    heldObject: state.predictions.heldObject,
  };
};

const ComponentWithIntl = injectIntl(Predictions37);

export default connect(mapStateToProps, {
  setHeldObject,
  setFragmentMass,
  reverseFragmentMass,
})((props) => (
  <TranslationsProvider fetchTranslations={fetchTranslations}>
    <ComponentWithIntl {...props} />
  </TranslationsProvider>
));
